import { useCookies } from "react-cookie";
import * as _ from "lodash";

export const useMiscellaneousHook = () => {
  const [cookies] = useCookies(["useMiscellaneousHook"]);
  const showStatusMessage = _.get(cookies, "useMiscellaneousHook", undefined);
  return showStatusMessage;
};
